import React from 'react';

import { Tooltip } from 'core/components/tooltip';
import useStyles from './applied-tag.styles';

const AppliedTag = () => {
  const classes = useStyles();

  return (
    <div className={classes.appliedTag}>
      Applied
      <Tooltip text="Coverages have been selected in this section." placement="top" />
    </div>
  );
};

export default AppliedTag;
